import {
  getGameDuration,
  getAllPlayers,
  getShifts,
  getLineupsWithPlayers,
  getGameData,
  getGameMinutes,
  getShiftStats,
} from './stats';
import { teamColors } from '../../../shared/chart-options';

export function getGameExplorerReport(stats) {
  const { gameDurationMinutes, overtimeMinutes } = getGameDuration(stats);
  const allPlayers = getAllPlayers(stats);
  const game = getGameData(stats);

  const lineupsWithPlayers = getLineupsWithPlayers(stats, allPlayers);
  const allShifts = getShifts(lineupsWithPlayers);
  const homeTeam = game.home.team;
  const visitorTeam = game.visitor.team;

  const homeShifts = getTeamShifts(
    allShifts,
    stats.home_shifts,
    gameDurationMinutes * 60,
    teamColors.homeColor,
  );
  const visitorShifts = getTeamShifts(
    allShifts,
    stats.visitor_shifts,
    gameDurationMinutes * 60,
    teamColors.visitorColor,
  );

  return {
    game,
    homeTeam,
    visitorTeam,
    homeShifts,
    visitorShifts,
    gameDurationMinutes,
    overtimeMinutes,
    allPlayers,
    allShifts,
    lineupsWithPlayers,
  };
}

function getTeamShifts(
  allShifts,
  teamIdShifts,
  gameDurationSeconds,
  teamColor,
) {
  return teamIdShifts
    .map(addTeamShiftInfo(allShifts))
    .map(addTeamShift(gameDurationSeconds, teamColor));
}

function addTeamShiftInfo(allShifts) {
  return shiftId => allShifts.find(shift => shift.id === shiftId);
}

function addTeamShift(gameDurationSeconds, teamColor) {
  return shift => ({
    ...shift,
    startShiftTime: getGameMinutes(
      shift.start_game_time_lig,
      gameDurationSeconds,
    ),
    endShiftTime: getGameMinutes(shift.end_game_time_lig, gameDurationSeconds),
    stats: getShiftStats(shift, gameDurationSeconds),
    teamColor,
  });
}
